import { instance } from "./axiosInterceptor";

const url = process.env.REACT_APP_API_URL;

// fetch all the series
export const fetchSeries = async () => {
  try {
    const token = await localStorage.getItem("token");
    const { data, status } = await instance.get(`${url}/api/v1/series?page=${1}&limit=${20}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (status === 200) {
      return data;
    }
    return null;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// fetch all the popular series
export const fetchPopularSeries = async () => {
  try {
    const token = await localStorage.getItem("token");
    const { data, status } = await instance.get(`${url}/api/v1/series-trends`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (status === 200) {
      return data;
    }
    return [];
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Fetch a specific series
export const fetchOneSeries = async (id: string) => {
  try {
    const token = await localStorage.getItem("token");
    const { data, status } = await instance.get(`${url}/api/v1/series/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// fetch bookmarked series
export const fetchBookmarkedSeries = async () => {
  try {
    const token = await localStorage.getItem("token");
    const { data, status } = await instance.get(
      `${url}/api/v1/bookmarks/series`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};
